import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=278df3de&scoped=true&"
import script from "./UploadPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&id=278df3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278df3de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278df3de')) {
      api.createRecord('278df3de', component.options)
    } else {
      api.reload('278df3de', component.options)
    }
    module.hot.accept("./UploadPhoto.vue?vue&type=template&id=278df3de&scoped=true&", function () {
      api.rerender('278df3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/UploadPhoto.vue"
export default component.exports